import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const arcadiaLocations = [
  {
    title: "Glacial Valley · Glenorchy",
    tag: "Mountain · Hero shot",
    img: "https://customer-assets.emergentagent.com/job_paradise-central/artifacts/gh84fay5_IMG_2278.jpeg",
  },
  {
    title: "Arcadia Homestead",
    tag: "Heritage · Victorian Manor",
    img: "/assets/arcadia-homestead.jpg",
  },
  {
    title: "Diamond Lake · Glenorchy",
    tag: "Lake · Reflection",
    img: "https://customer-assets.emergentagent.com/job_paradise-central/artifacts/tvxc5ki8_DJI_0167.JPG",
  },
  {
    title: "Pastoral Run",
    tag: "Livestock · Snow Peaks",
    img: "https://customer-assets.emergentagent.com/job_paradise-central/artifacts/zqrn8o4p_IMG_0374.jpeg",
  },
  {
    title: "Beech Forest",
    tag: "Forest · Canopy",
    img: "https://customer-assets.emergentagent.com/job_paradise-central/artifacts/9ywzv7b6_1106NZ_L1007745.HEIC",
  },
];

export default function ArcadiaStation() {
  return (
    <section
      id="arcadia"
      data-testid="arcadia-section"
      className="relative py-28 md:py-40 border-t border-white/5 overflow-hidden"
    >
      {/* Background photo */}
      <div
        aria-hidden
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://customer-assets.emergentagent.com/job_paradise-central/artifacts/513usyr0_DJI_0176.JPG)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-b from-[#050505]/95 via-[#050505]/75 to-[#050505]/95"
      />
      <div aria-hidden className="absolute inset-0 bg-[#050505]/40" />

      <div className="relative max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-6 h-px bg-[#E2B464]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E2B464]">
                Our Namesake · Heritage
              </span>
            </div>
            <h2 className="font-display font-light text-4xl md:text-6xl leading-none tracking-tighter max-w-3xl">
              Arcadia Station,{" "}
              <span className="italic text-[#E2B464]">Paradise.</span>
            </h2>
          </div>
          <p className="text-zinc-400 max-w-sm leading-relaxed text-sm">
            Paradise Studios takes its name from the historic Arcadia Station at
            Paradise, a head-of-lake homestead 16 km north of Glenorchy, framed
            by Mt Earnslaw, Mt Alfred, Diamond Lake and the Dart River.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {arcadiaLocations.map((loc, i) => (
            <motion.button
              key={loc.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              data-testid={`arcadia-card-${i}`}
              className="group relative overflow-hidden aspect-[4/5] text-left border border-white/10 hover:border-[#E2B464]/60 transition-colors"
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                style={{ backgroundImage: `url(${loc.img})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/30 to-transparent" />
              <div className="relative h-full flex flex-col justify-between p-6 md:p-8">
                <div className="flex items-start justify-between">
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-300 bg-black/40 backdrop-blur px-2.5 py-1 border border-white/10">
                    {loc.tag}
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <div>
                  <h3 className="font-display text-2xl md:text-3xl text-white tracking-tight leading-tight">
                    {loc.title}
                  </h3>
                </div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
